import { forwardRef, type InputHTMLAttributes } from 'react';
import { cn } from '@/lib/cn';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  invalid?: boolean;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { invalid, className, ...rest },
  ref,
) {
  return (
    <input
      ref={ref}
      aria-invalid={invalid || undefined}
      className={cn(
        'h-10 w-full rounded border bg-white px-3 text-sm text-brand-charcoal',
        'placeholder:text-brand-gray-mid',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-blue focus-visible:ring-offset-1',
        'disabled:cursor-not-allowed disabled:bg-brand-gray-light disabled:opacity-60',
        invalid
          ? 'border-brand-danger focus-visible:ring-brand-danger'
          : 'border-brand-gray-light hover:border-brand-gray-mid',
        className,
      )}
      {...rest}
    />
  );
});
